import "./CertificateGroupingWithoutRating.scss";
import CertificateWithoutRating from "../../features/ServiceCertificateGrouping/CaseOfficerReviewForm/CertificateWithoutRating/CertificateWithoutRating"

const CertificateGroupingWithoutRating = () => {
  return (
    <div className="analytics-page">
      <CertificateWithoutRating />
    </div>
  );
};

export default CertificateGroupingWithoutRating;
